import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

const canCreateWorkspaces = (roleIds: string[], teamId?: string) => {
  return teamId ? roleIds.includes("team_owner") || roleIds.includes("team_editor") : roleIds.includes("pro_user");
};

const canCreateTeams = (roleIds: string[]) => {
  return roleIds.includes("pro_user");
};

const canEditTeam = (roleIds: string[]) => {
  return roleIds.includes("team_owner");
};

const canEditWorkspaces = (roleIds: string[], teamId?: string) => {
  return teamId ? roleIds.includes("team_owner") || roleIds.includes("team_editor") : true;
};

const canDeleteWorkspaces = (roleIds: string[], teamId?: string) => {
  return teamId ? roleIds.includes("team_owner") || roleIds.includes("team_editor") : roleIds.includes("pro_user");
};

const canCreateResources = (roleIds: string[], teamId?: string) => {
  return teamId ? roleIds.includes("team_owner") || roleIds.includes("team_editor") : true;
};

const canManageTeams = (roleIds: string[]) => {
  return roleIds.includes("pro_user");
};

const canDeploy = (roleIds: string[]) => {
  return roleIds.includes("pro_user");
};

export const getPermissions = async (teamId?: string) => {
  const { data: roles } = await supabase.rpc("get_user_roles", teamId ? { p_team_id: teamId } : undefined);

  const roleIds = roles?.map((role: { role: string }) => role.role) || [];

  return {
    canCreateWorkspaces: canCreateWorkspaces(roleIds, teamId),
    canCreateTeams: canCreateTeams(roleIds),
    canEditTeam: canEditTeam(roleIds),
    canEditWorkspaces: canEditWorkspaces(roleIds, teamId),
    canDeleteWorkspaces: canDeleteWorkspaces(roleIds, teamId),
    canCreateResources: canCreateResources(roleIds, teamId),
    canEditResources: canEditWorkspaces(roleIds, teamId),
    canManageTeams: canManageTeams(roleIds),
    canDeploy: canDeploy(roleIds),
  };
};

export const usePermissions = (teamId?: string) => {
  return useQuery({
    queryKey: ["permissions", teamId || ""],
    queryFn: () => getPermissions(teamId || ""),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
